import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Room} from '../../models/room.class';
import {RoomService} from '../../services/room/room.service';

@Component({
  selector: 'app-dialog-confirm-delete-room',
  templateUrl: './dialog-confirm-delete-room.component.html',
  styleUrls: ['./dialog-confirm-delete-room.component.scss']
})
export class DialogConfirmDeleteRoomComponent implements OnInit {
  public room: Room;
  public value: string;
  public loadingPage: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogConfirmDeleteRoomComponent>,
    private roomService: RoomService
  ) {}

  ngOnInit() {
    this.room = this.data.room;
    this.value = '';
    this.loadingPage = false;
  }

  public async delete() {
    this.loadingPage = true;
    try {
      await this.roomService.deleteRoom(this.room.id).then(res => {
        this.dialogRef.close(true);
  
            });
  } catch (error) {
    this.dialogRef.close(false);
    
  }
    
  }
}
